import { render, staticRenderFns } from "./VerticalNavMenuItem.vue?vue&type=template&id=6b8ba7f1&scoped=true&"
import script from "./VerticalNavMenuItem.vue?vue&type=script&lang=js&"
export * from "./VerticalNavMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./VerticalNavMenuItem.vue?vue&type=style&index=0&id=6b8ba7f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8ba7f1",
  null
  
)

export default component.exports